import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  contentWrap: FelaCSS;
  buttonWrap: FelaCSS;
  modalStyleReset: FelaCSS;
}

const styles = (): IStyles => ({
  contentWrap: {
    position: 'relative',
    maxWidth: 360,
    alignSelf: 'center',
    paddingTop: 8,
    paddingHorizontal: 6,
    paddingBottom: '6',
    borderRadius: '16px',
    backgroundColor: colors.white,
  },

  buttonWrap: {
    position: 'absolute',
    right: '4px',
    top: '4px',
    zIndex: 1,
  },

  modalStyleReset: {
    maxWidth: '100%',
    paddingTop: 0,
    paddingHorizontal: 0,
    paddingBottom: 0,
  },
});

export default styles;
